import { render, staticRenderFns } from "./wholesale-cart-item.vue?vue&type=template&id=10153de2&scoped=true"
import script from "./wholesale-cart-item.vue?vue&type=script&lang=js"
export * from "./wholesale-cart-item.vue?vue&type=script&lang=js"
import style0 from "./wholesale-cart-item.vue?vue&type=style&index=0&id=10153de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10153de2",
  null
  
)

export default component.exports